export const checkStrings = (strings: string[]): boolean => {
  return strings
    .map(s => {
      return typeof s === "string" && s !== undefined && s !== null && s !== "";
    })
    .reduce((acc, curr) => acc && curr, true);
};
